<template>
  <Drawer
      :title="title"
      v-model="isBox"
      width="100%"
      :mask-closable="false"
      @on-close="FormReset()"
      class-name="drawer-default"
  >
    <div class="set-scroll-form">
      <Row :gutter="32">
        <Col :span="4">
          <Form ref="SearchForms" :model="SearchForms" :rules="SearchRules"  label-position="top">
            <Row :gutter="32">
              <Col :span="24">
                <FormItem label="项目" prop="project_id">
                  <Select class="search-select"  v-model="SearchForms.project_id"  clearable filterable  placeholder="收款项目">
                    <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :span="24">
                <FormItem label="客户" prop="customer_id">
                  <Select class="search-select" v-model="SearchForms.customer_id"  clearable filterable  placeholder="收款客户">
                    <Option :value="item.id" v-for="(item,index) in customerList" :key="index">{{item.company}}</Option>
                  </Select>
                </FormItem>
              </Col>
              <Col :span="24">
                <FormItem label="编号" prop="sn">
                  <Input class="search-input" clearable v-model="SearchForms.sn" placeholder="收入编号" />
                </FormItem>
              </Col>
              <Col :span="24">
                <FormItem label="日期" prop="time">
                  <DatePicker class="width-100" v-model="SearchForms.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="选择日期" />
                </FormItem>
              </Col>
              <Col :span="24">
                <Button type="warning" icon="ios-search" @click="SearchSubmit()">查询记录</Button>
              </Col>
              <Col :span="24">
                <br />
                <DescriptionList class="show-description-title" title="" :col="3"  layout="vertical">
                  <Description term="发票金额：">
                    {{invoice.inv_money ?? '0.00'}}
                  </Description>
                  <Description term="选中金额：">
                    {{selectMoney}}
                  </Description>
                  <Description term="剩余金额：">
                    {{useMoney}}
                  </Description>
                </DescriptionList>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col :span="20">
          <Table row-key="inv_id" ref="selection" stripe border :columns="columns" @on-selection-change="tableCheckAll"  :data="dataList" no-data-text="暂无数据记录" height="520">
            <template #sn="{ row }">
              <div class="d-width cursor text-primary" :title="row.sn" @click="showData(row.inv_id)">
                <span>{{row.sn}}</span>
              </div>
            </template>
            <template #status="{ row }">
              <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
              <Badge v-else-if="row.status === 2" color="orange" :text="row.status_name" />
              <Poptip v-else-if="row.status === 4" trigger="hover" width="240" :word-wrap="true" title="到账信息：" >
                <Badge color="green" :text="row.status_name" />
                <template #content>
                  <p style="white-space: normal;">金额：<span class="text-success">{{row.get_money}}</span></p>
                  <p style="white-space: normal;">时间：{{row.get_date}}</p>
                </template>
              </Poptip>
              <Poptip v-else-if="row.status === 3" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                <Badge color="red" :text="row.status_name" />
                <template #content>
                  <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                  <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                </template>
              </Poptip>
              <Badge v-else color="#999999" text="其他" />
            </template>
            <template #is_invoice="{ row }">
              <Badge v-if="row.is_invoice === 1" color="#999" :text="row.is_invoice_name" />
              <Badge v-else-if="row.is_invoice === 2" color="blue" :text="row.is_invoice_name" />
              <Badge v-else-if="row.is_invoice === 3" color="orange" :text="row.is_invoice_name" />
              <Badge v-else-if="row.is_invoice === 4" color="green" :text="row.is_invoice_name" />
              <Badge v-else color="#999999" text="其他" />
            </template>
            <template #money="{ row }">
              <span>{{row.money}}</span>
            </template>
            <template #true_money="{ row }">
              <span class="text-success">{{row.true_money}}</span>
            </template>
            <template #use_inv_money="{ row }">
              <span class="text-orange">{{row.use_inv_money}}</span>
            </template>
            <template #apply_id="{ row }">
              <div class="d-width" :title="row.apply_name">
                <span>{{row.apply_name}}</span>
              </div>
            </template>
            <template #project_id="{ row }">
              <div class="d-width" :title="row.project_name">
                <span>{{row.project_name}}</span>
              </div>
            </template>
            <template #customer_id="{ row }">
              <div class="d-width" :title="row.company">
                <span>{{row.company}}</span>
              </div>
            </template>
            <template #remark="{ row }">
              <div class="d-width" :title="row.remark">
                <span>{{row.remark ?? '-'}}</span>
              </div>
            </template>
          </Table>
          <div class="em-page">
            <div class="em-page-btn">
              <span class="text-999">选中 <em class="text-danger">{{selectCount}}</em> 条记录</span>
              <Divider type="vertical" />
              <span class="text-999 mr10">共</span>
              <strong class="text-orange">{{selectMoney}}</strong>
              <span class="text-999"> 元</span>
            </div>
          </div>
        </Col>
      </Row>
      <div class="box-drawer-footer">
        <Button class="mr10" @click="FormReset()">取消</Button>
        <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">确认发票绑定</Button>
      </div>

      <!-- 项目支出详情  -->
      <show-income-modal v-if="is_show" ref="ShowIncomeRef"></show-income-modal>
    </div>
  </Drawer>
</template>

<script>

import {getIncomeSearchList} from "@/apis/income";
import ShowIncomeModal from "@/view/income/Show";
import {getInvoiceConfig, getInvoiceDetail, bindInvoice} from "@/apis/invoice";


export default {
  name: 'InvoiceBind',
  components: {
    ShowIncomeModal
  },
  emits: ['trueHandler'],
  data () {
    return {
      title : '发票绑定收款',
      isBox : false,
      is_show : false,
      bind_invoice_id: 0,
      invoice: [],

      customerList: [],
      projectList: [],
      SearchForms: {
        project_id: '',
        customer_id: '',
        sn: '',
        time: []
      },
      SearchRules: {},
      dataList : [],
      selectCount  : 0,
      selectMoney  : 0,
      useMoney  : 0,
      columns: [
        {
          type: 'selection',
          width: 55,
          align: 'center',
          fixed : 'left'
        },
        {
          title: '收款编号',
          key: 'sn',
          slot: 'sn',
          width: 160
        },
        {
          title: '收款状态',
          key: 'status',
          slot: 'status',
          width: 120,
        },
        {
          title: '发票状态',
          key: 'is_invoice',
          slot: 'is_invoice',
          width: 120,
        },
        {
          title: '金额',
          key: 'money',
          slot: 'money',
          width: 140,
        },
        {
          title: '实收',
          key: 'true_money',
          slot: 'true_money',
          width: 140,
        },
        {
          title: '已开金额',
          key: 'use_inv_money',
          slot: 'use_inv_money',
          width: 140,
        },
        {
          title: '申请人',
          key: 'apply_id',
          slot: 'apply_id',
          width:100
        },
        {
          title: '报销项目',
          key: 'project_id',
          slot: 'project_id',
          width: 180,
        },
        {
          title: '客户',
          key: 'customer_id',
          slot: 'customer_id',
          width: 180,
        },
        {
          title: '备注',
          key: 'remark',
          slot: 'remark'
        }
      ],
    }
  },
  methods: {
    tableCheckAll(){
      let that = this;
      const data = that.$refs.selection.getSelection();
      that.selectCount = data.length;
      var money = 0;
      data.forEach(item => {
        money = money + parseFloat(item.true_money * 100 / 100) - parseFloat(item.use_inv_money * 100 / 100)
      })
      that.selectMoney = money + parseFloat(that.invoice.use_inv_money * 100 / 100);
      that.useMoney = parseFloat(that.invoice.inv_money * 100 / 100) - that.selectMoney;
    },
    showData(id){
      let that = this;
      that.is_show = true;
      setTimeout(function(){
        that.$refs.ShowIncomeRef.show(id);
      })
    },
    getList(){
      let that = this;
      that.selectMoney = that.invoice.use_inv_money;
      that.selectCount = 0;
      that.useMoney = that.invoice.inv_money - that.invoice.use_inv_money;
      const params = {
        search : that.SearchForms
      };
      getIncomeSearchList(params).then(e=>{
        that.dataList = e.data;
      })
    },
    getConfig(){
      let that = this;
      getInvoiceConfig().then(e=>{
        that.projectList = e.data.projectList ?? [];
        that.customerList = e.data.customerList ?? [];
      })
    },
    getInvoiceDetail(inv_id){
      let that = this;
      that.$store.commit('SET_LOADING' , true);
      getInvoiceDetail(inv_id).then(e => {
        that.invoice = e.data;
        that.useMoney = e.data.inv_money - e.data.use_inv_money;
        that.selectMoney =  e.data.use_inv_money;
      })
    },

    /**
     功能：
     time: 2025/12/17 10:47
     **/
    show(id){
      this.isBox = true;
      this.bind_invoice_id = parseInt(id);
      this.getConfig();
      this.getInvoiceDetail(this.bind_invoice_id);
    },

    SearchSubmit(){
      let that = this;
      this.$refs['SearchForms'].validate((valid) => {
        if (valid) {
          that.getList();
        }
      })
    },
    /**
     功能：
     time: 2025/12/26 16:14
     **/
    FormSubmit(){
      let that = this;
      const data = that.$refs.selection.getSelection();
      if(data.length <= 0){
        that.$Message.error({ background: true, content:'至少选择一条记录'});
        return false;
      }
      let ids = [];
      for(var i  = 0; i < data.length; i++ ){
        ids.push(data[i].id);
      }
      if(ids.length > 0){
        this.$Modal.confirm({
          title: '批量绑定发票',
          content: '此操作将批量绑定发票不可恢复, 是否继续?',
          onOk: () => {
            that.$store.commit('SET_LOADING' , true);
            bindInvoice({inv_id:that.invoice.inv_id, ids:ids}).then( e =>{
              that.$Message.success({ background: true,duration:3, content: e.msg });
              that.FormReset();
              that.$emit('trueHandler');
            })
          },
          onCancel: () => {}
        });
      }
    },
    /**
     功能：
     time: 2025/12/20 11:54
     **/
    FormReset(){
      this.isBox = false;
      this.title = '发票绑定收款';
      this.$refs['SearchForms'].resetFields();
      this.SearchForms = {
        project_id: '',
        customer_id: '',
        sn: '',
        time: []
      };
      this.selectCount = 0;
      this.selectMoney = 0;
      this.useMoney = 0;
      this.dataList = [];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
